import classnames from 'classnames';
import { colors, screen } from 'components/styles/variables';

export interface PercentageBarProps {
  label: string;
  value: number;
  color?: 'gold' | 'red';
}

export default function PercentageBar({ label, value, color }: PercentageBarProps): JSX.Element {
  const isGold = color === 'gold';

  return (
    <div className="percentage-bar-container">
      <div className="percentage-bar-label">{label}</div>
      <div className="percentage-bar">
        <div className="grey-bar">
          <div
            className={classnames('filled-bar', {
              'gold-bar': isGold,
              'red-bar': !isGold,
            })}
          />
        </div>
      </div>
      <div className="percentage-bar-percentage">{`${value}%`}</div>
      <style jsx>{`
        .percentage-bar {
          display: flex;
          flex-grow: inherit;
        }

        .percentage-bar-container {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          flex-grow: 1;
        }
        .percentage-bar-label {
          padding-right: 12px;
          font-size: 14px;
          text-wrap: nowrap;
        }
        .percentage-bar-percentage {
          padding-left: 12px;
        }
        .grey-bar {
          height: 12px;
          width: 168px;
          background: ${colors.G1};
          border: 1px solid ${colors.G2};
          border-radius: 4px;
          position: relative;
          flex-grow: inherit;
        }
        @media (min-width: ${screen.xsMax}) and (max-width: 849px) {
          .grey-bar {
            width: 468px;
          }
        }
        .filled-bar {
          height: 12px;
          width: ${value}%;
          border-radius: 4px 0 0 4px;
          position: absolute;
          top: -1px;
          left: -1px;
        }
        .gold-bar {
          background: ${colors.ALY1};
          border: 1px solid ${colors.ALY2};
        }
        .red-bar {
          background: ${colors.ALR1};
          border: 1px solid ${colors.ALR2};
        }
      `}</style>
    </div>
  );
}
